module.exports = __webpack_public_path__ + "img/Thinxtra_Logo.cdc3b79f.png";